import styled from '@emotion/native'
import React, { FC } from 'react';
import * as utils from '@lib/utils';
import { useFonts } from 'expo-font';
import { ColorValue } from 'react-native';

const Container = styled.Text`
  font-family: PublicSans;
  
  ${props => props.thin && `font-family: PublicSansThin;`}
  ${props => props.bold && `font-family: PublicSansBold;`}

  color: ${(props: any) => props.color || props.theme.pallete.textColor};
  
  ${props => props.align && `text-align: ${props.align}`}

  ${props => props.contrasted && `
    text-shadow-color: white;
    textShadowOffset: 1px;
    text-shadow-radius: 1px;
  `}
  
  ${props => props.supper && `
    position: relative;
    top: -9px;
  `}
  
  ${props => props.ellipsis && `
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`;

const XLarge = styled(Container)`
  font-size: 30px;
  line-height: 35.25px;
`;

const Large = styled(Container)`
  font-size: 18px;
  line-height: 18px;
`;

const Normal = styled(Container)`
  font-size: 16px;
  line-height: 18px;
`;

const Small = styled(Container)`
  font-size: 14px;
  line-height: 16px;
`;

const XSmall = styled(Container)`
  font-size: 11px;
  line-height: 13px;
  letter-spacing: -0.08px;
`;


const Text: FC<Props> = ({ children, preffix = "", suffix ="", decimal, hidden, currency = null, xlarge, large, small, xsmall, ...props }) => {

    const [loaded] = useFonts({
      "PublicSansThin": require('@assets/fonts/PublicSans-Thin.ttf'),
      "PublicSans": require('@assets/fonts/PublicSans-Regular.ttf'),
      "PublicSansBold": require('@assets/fonts/PublicSans-Bold.ttf'),
    });

    // If the text is a decimal
    if( decimal && (typeof children).localeCompare("number") === 0) {
      children = utils.printDecimalOf(children);
    }
    // If the text represents a currency amount
    else if ( currency && (typeof children).localeCompare("number") === 0) {
      let amount = parseFloat(children as string);
      if(amount < 0) {
        children = `-${currency}${utils.printDecimalOf(Math.abs(amount))}`;
      } else {
        children = `${currency}${utils.printDecimalOf(Math.abs(amount))}`;
      }
    }

    if(!loaded){
      return null;
    }
    else if(hidden) {
      return  <Text xlarge>-- <Text>Hidden</Text> --</Text>;
    }
    else if(xlarge){
      return (<XLarge {...props}>{preffix}{children}{suffix}</XLarge>)
    }
    else if(large){
      return (<Large {...props}>{preffix}{children}{suffix}</Large>)
    }
    else if(small){
      return (<Small {...props}>{preffix}{children}{suffix}</Small>)
    }
    else if(xsmall){
      return (<XSmall {...props}>{preffix}{children}{suffix}</XSmall>)
    }
    else{
      return (<Normal {...props}>{preffix}{children}{suffix}</Normal>);
    }

  }

  export type Props = {
    pointerEvents?: string;
    children?: React.ReactNode | Text | string | number;
    preffix?: string;
    suffix?: string;
    decimal?: boolean;
    currency?: string;
    autoComplete?: string;

    bold?: boolean;
    thin?: boolean;

    ellipsis?: boolean;
    contrasted?: boolean;
    hidden?: boolean;
    
    color?: string;
    align?: string;
    supper?: boolean;
    style?: object;
    xlarge?: boolean;
    large?: boolean;
    xsmall?: boolean;
    small?: boolean;
  };

  export default Text;
  
  
  export const HeadingText = styled(Text)`
    padding: 16px 48px;
    font-size: 24px;
    line-height: 36px;
    width: 348px;
`;